<template>
  <b-card :title="title ? $t(title) : ''" class="search-list">
    <div class="d-flex">
      <div class="outline-none" tabindex="0" @keyup.enter="$emit('search')" style="width: 90%; margin-right: 40px">
        <slot></slot>
      </div>

      <div style="width: 10%; padding-left: 20px">
        <LoadingButton className="mt-3" variant="primary" @click="$emit('search')">
          <ez-icon icon="ezAr-icon-search" style="margin-right: 3px" />{{
            buttonText ? $t(buttonText) : $t("ar_common_search")
          }}</LoadingButton
        >
      </div>
    </div>
  </b-card>
</template>
<style lang="scss">
.search-list {
  form {
    padding: 0;
  }
}
</style>
<script>
import { defineComponent } from "@vue/composition-api";
import LoadingButton from "../Button/LoadingButton.vue";

export default defineComponent( {
  name: "SearchList",
  emits:["search"],
  props: {
    styles: String,
    title: String,
    buttonText: String,
  },
  components: { LoadingButton },
});
</script>
